import { render, staticRenderFns } from "./PopupButtonBack.vue?vue&type=template&id=d3533ec4&scoped=true"
import script from "./PopupButtonBack.vue?vue&type=script&lang=js"
export * from "./PopupButtonBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3533ec4",
  null
  
)

export default component.exports